module.exports = __webpack_public_path__ + "officialStatic/img/soft8.a250298.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft8.png
// module id = 71SW
// module chunks = 0